// @flow
import * as React from 'react'
import { nest } from 'd3-collection'
import { max } from 'd3-array'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/flag.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'

const halfTree = require('./img/tree-half.png')
const fullTree = require('./img/tree-full.png')
const emptyTree = require('./img/tree-empty.png')

type Props = {
  dataSet: string[]
}

type State = {
  nestedData: string[]
}

export class Trees extends React.Component<Props, State> {
  componentWillMount () {
    let nestedData = nest()
      .key(function (d) {
        return d.year
      })
      .entries(this.props.dataSet)

    console.log(nestedData)

    nestedData.forEach(function (d) {
      d.year = +d.key
      d.snow24 = +d.values[0].snowZH
      d.snow25 = +d.values[1].snowZH
      d.snow26 = +d.values[2].snowZH
      d.average = (d.snow24 + d.snow25 + d.snow26) / 3
      d.max = max([d.snow24, d.snow25, d.snow26])
      d.yearShort = d.key.slice(2, 4)

      if (d.snow24 + d.snow25 + d.snow26 < 1) {
        d.tree = emptyTree
      } else if (d.snow24 > 0 && d.snow25 > 0 && d.snow26 > 0) {
        d.tree = fullTree
      } else {
        d.tree = halfTree
      }
    })
    this.setState({
      nestedData: nestedData
    })
  }

  render () {
    const forest = []
    for (let i = 0; i < this.state.nestedData.length; i++) {
      let singleTree = this.state.nestedData[i]
      forest.push(
        <div className='tree container' key={`tree-container-${i}`}>
          <img
            width='100%'
            src={singleTree.tree}
            className='single tree'
            key={`tree-${i}`}
          />
          <p>
            {window.outerWidth < 599 && (
              <span>
                {i === 0 || i === this.state.nestedData.length - 1
                  ? singleTree.year
                  : "'" + singleTree.yearShort}
              </span>
            )}
            {window.outerWidth >= 600 && singleTree.year}
          </p>
        </div>
      )
    }
    return (
      <div className='trees'>
        <div
          className={`ui ${window.outerWidth < 599
            ? 'unstackable'
            : 'stackable'} grid`}
        >
          <div className='three column row center aligned'>
            <div className='column'>
              <img width='100%' src={fullTree} className='single legend tree' />
              <p className='legend'>Drei weisse Weihnachtstage</p>
            </div>
            <div className='column'>
              <img width='100%' src={halfTree} className='single legend tree' />
              <p className='legend'>Mindestens einen Tag mit Schnee</p>
            </div>
            <div className='column'>
              <img
                width='100%'
                src={emptyTree}
                className='single legend tree'
              />
              <p className='legend'>Alle drei Tage ohne Schnee</p>
            </div>
          </div>
          <div className='one column row'>
            <div className='column'>
              {forest}
              <p className='forecast'>
                <img src={require('./img/arrow-left.svg')} />
                <span>Prognose</span>
              </p>
            </div>
            <div className='column'>
              <p className='source'>
                Quelle: Meteo Schweiz, Station Zürich-Fluntern
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Trees
